import { commonTokens, lodestarColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { sizes } from "../constants/spacing";
import { ThemeObject } from "./types";
import { getCSSVariables } from "./utils/getCSSVariables";

export const lodestarTheme: ThemeObject = {
    key: "lodestar-light",
    cssVariables: getCSSVariables("com", "lodestar-light", commonTokens),
    skipLink: {
        container: {
            bg: color("color--background--surfaces--body"),
            borderRadius: `0 0 ${sizes.xxSmall}px ${sizes.xxSmall}px`,
            top: "0",
            padding: `0 ${sizes.medium}px`,
            height: "40px",
            boxShadow: color("elevation--default"),
            gap: "xLarge",
        },
        button: {
            color: lodestarColors.ctaLink,
            padding: "3px 6px",
            fontSize: "13px",
            lineHeight: "normal",
            borderRadius: "4px",
            focusRingGap: -1,
        },
    },
};
